import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ChartService } from '../../../services/chart.service';

@Component({
  selector: 'app-predictive-maintenance',
  templateUrl: './predictive-maintenance.component.html',
  styleUrl: './predictive-maintenance.component.scss',
  standalone: false,
})
export class PredictiveMaintenanceComponent implements OnInit {
  isBrowser = false;
  drilldownTitle: string = '';
  showDrilldown: boolean = false;

  constructor(
    private chartService: ChartService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  timeFrames = ['Mensuel', 'Trimestriel', 'Annuel'];
  activeTimeFrame = 'Trimestriel';
  gainsData = {
    costsAvoided: 367500,
    costsGrowth: 22,
    downtimeAvoided: 284,
    downtimeGrowth: 15,
    roi: 418,
    roiGrowth: 5,
  };

  gainsChartData: any;
  gainsChartOptions: any;
  drilldownChartData: any;
  drilldownChartOptions: any;

  ngOnInit(): void {
    this.getGainsChartData();
    this.getGainsChartOptions();
    this.showGainsByCategory();
    this.drilldownChartOptions = this.chartService.getPieChartOptions();
  }
  getGainsChartData() {
    this.chartService.getGainsChartData().subscribe((data) => {
      this.gainsChartData = data;
    });
  }

  getGainsChartOptions() {
    this.gainsChartOptions = this.chartService.getGainsChartOptions();
  }

  showGainsByCategory(): void {
    this.drilldownTitle = 'Distribution des gains par catégorie';
    /*this.chartService.getGainsDrilldownData('category').subscribe(data => {
      this.drilldownChartData = data;
      this.showDrilldown = true;
    });*/
  }

  showGainsByEquipment(): void {
    this.drilldownTitle = 'Distribution des gains par équipement';
    /*this.chartService.getGainsDrilldownData('equipment').subscribe(data => {
      this.drilldownChartData = data;
      this.showDrilldown = true;
    });*/
  }
}
